import { withInstall, SFCWithInstall } from '@touchvue/utils'
import DateRange from './src/date-range.vue'

export const ToDateRange: SFCWithInstall<typeof DateRange> = withInstall(DateRange)
export * from './src/date-range.vue'
